import { render, staticRenderFns } from "./PackageVariantClosedCheck.vue?vue&type=template&id=462d0e56"
import script from "./PackageVariantClosedCheck.vue?vue&type=script&lang=js"
export * from "./PackageVariantClosedCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports